import { render } from "./personInfo.vue?vue&type=template&id=fe0c53ea&scoped=true&ts=true"
import script from "./personInfo.vue?vue&type=script&lang=ts"
export * from "./personInfo.vue?vue&type=script&lang=ts"

import "./personInfo.vue?vue&type=style&index=0&id=fe0c53ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0c53ea"]])

export default __exports__